import React from 'react';
import { Link } from 'react-router-dom';

function Jobcategories({ categories }) {

	return (
		<div className="row sp20">
			<div className="col-lg-3 col-md-6 col-sm-6">
				<div className="icon-bx-wraper">
					<div className="icon-content">
						<div className="icon-md text-primary m-b20"><i className="ti-location-pin"></i></div>
						<Link to="#" className="dez-tilte">{categories?.[0]?.category__name}</Link>
						<p className="m-a0">{categories?.[0]?.total} Open Positions</p>
						<div className="rotate-icon"><i className="ti-location-pin"></i></div>
					</div>
				</div>
			</div>
			<div className="col-lg-3 col-md-6 col-sm-6">
				<div className="icon-bx-wraper">
					<div className="icon-content">
						<div className="icon-md text-primary m-b20"><i className="ti-wand"></i></div>
						<Link to="#" className="dez-tilte">{categories?.[1]?.category__name}</Link>
						<p className="m-a0">{categories?.[1]?.total} Open Positions</p>
						<div className="rotate-icon"><i className="ti-wand"></i></div>
					</div>
				</div>
			</div>
			<div className="col-lg-3 col-md-6 col-sm-6">
				<div className="icon-bx-wraper">
					<div className="icon-content">
						<div className="icon-md text-primary m-b20"><i className="ti-wallet"></i></div>
						<Link to="#" className="dez-tilte">{categories?.[2]?.category__name}</Link>
						<p className="m-a0">{categories?.[2]?.total} Open Positions</p>
						<div className="rotate-icon"><i className="ti-wallet"></i></div>
					</div>
				</div>
			</div>
			<div className="col-lg-3 col-md-6 col-sm-6">
				<div className="icon-bx-wraper">
					<div className="icon-content">
						<div className="icon-md text-primary m-b20"><i className="ti-cloud-up"></i></div>
						<Link to="#" className="dez-tilte">{categories?.[3]?.category__name}</Link>
						<p className="m-a0">{categories?.[3]?.total} Open Positions</p>
						<div className="rotate-icon"><i className="ti-cloud-up"></i></div>
					</div>
				</div>
			</div>
			<div className="col-lg-3 col-md-6 col-sm-6">
				<div className="icon-bx-wraper">
					<div className="icon-content">
						<div className="icon-md text-primary m-b20"><i className="ti-bar-chart"></i></div>
						<Link to="#" className="dez-tilte">{categories?.[4]?.category__name}</Link>
						<p className="m-a0">{categories?.[4]?.total} Open Positions</p>
						<div className="rotate-icon"><i className="ti-bar-chart"></i></div>
					</div>
				</div>
			</div>
			<div className="col-lg-3 col-md-6 col-sm-6">
				<div className="icon-bx-wraper">
					<div className="icon-content">
						<div className="icon-md text-primary m-b20"><i className="ti-tablet"></i></div>
						<Link to="#" className="dez-tilte">{categories?.[5]?.category__name}</Link>
						<p className="m-a0">{categories?.[5]?.total} Open Positions</p>
						<div className="rotate-icon"><i className="ti-tablet"></i></div>
					</div>
				</div>
			</div>
			<div className="col-lg-3 col-md-6 col-sm-6">
				<div className="icon-bx-wraper">
					<div className="icon-content">
						<div className="icon-md text-primary m-b20"><i className="ti-camera"></i></div>
						<Link to="#" className="dez-tilte">{categories?.[6]?.category__name}</Link>
						<p className="m-a0">{categories?.[6]?.total} Open Positions</p>
						<div className="rotate-icon"><i className="ti-camera"></i></div>
					</div>
				</div>
			</div>
			<div className="col-lg-3 col-md-6 col-sm-6">
				<div className="icon-bx-wraper">
					<div className="icon-content">
						<div className="icon-md text-primary m-b20"><i className="ti-panel"></i></div>
						<Link to="#" className="dez-tilte">{categories?.[7]?.category__name}</Link>
						<p className="m-a0">{categories?.[7]?.total} Open Positions</p>
						<div className="rotate-icon"><i className="ti-panel"></i></div>
					</div>
				</div>
			</div>
			<div className="col-lg-12 text-center m-t30">
				<button className="site-button radius-xl">All Categories</button>
			</div>
		</div>
	)
}

export default Jobcategories;